import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { articles } from '../../mocks/articles';

export default function ArticlesListPage() {
  const categories = ['All', 'Schedule', 'Results', 'Transfer', 'Analysis'];
  const selectedCategory = 'All';

  const filteredArticles = selectedCategory === 'All' 
    ? articles 
    : articles.filter(a => a.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <nav className="bg-gray-100 py-3 border-b border-gray-300">
        <div className="max-w-[1200px] mx-auto px-4">
          <div className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-blue-600 hover:underline">Home</Link>
            <span className="text-gray-500">›</span>
            <span className="text-gray-700">Articles</span>
          </div>
        </div>
      </nav>

      <main className="max-w-[1200px] mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Football Articles</h1>
        
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map(cat => (
            <button
              key={cat}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                selectedCategory === cat
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredArticles.map(article => (
            <article key={article.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
              <Link to={`/libraries/pgss/${article.slug}`}>
                <img 
                  src={article.image} 
                  alt={article.title}
                  className="w-full h-48 object-cover"
                  loading="lazy"
                />
              </Link>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-semibold px-2 py-1 bg-blue-100 text-blue-700 rounded">
                    {article.category}
                  </span>
                  <time className="text-xs text-gray-500">{article.date}</time>
                </div>
                <Link to={`/libraries/pgss/${article.slug}`}>
                  <h2 className="text-lg font-bold mb-2 hover:text-blue-600 line-clamp-2">
                    {article.title}
                  </h2>
                </Link>
                <p className="text-sm text-gray-600 line-clamp-3 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-1">
                  {article.tags.slice(0, 3).map(tag => (
                    <span key={tag} className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </main>
      
      <Footer />
    </div>
  );
}